module.exports = __webpack_public_path__ + "img/img0615.2001150c.jpg";